<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout
      justify-center
      py-3
      wrap
    >
      <v-flex
        xs12
        md10
        xl8
      >
        <SimpleCard>
          <v-flex
            pl-3
            pb-4
          >
            <v-layout
              justify-start
              align-content-start
              wrap
            >
              <v-flex xs12>
                <h4>Admin Settings</h4>
              </v-flex>
              <v-flex xs6>
                <v-layout align-center>
                  <v-text-field
                    v-model="systemName"
                    label="System Name"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="companyAddress"
                    label="Company Address"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="systemCode"
                    label="System Code"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="stripePublishableKey"
                    label="Stripe Publishable Key"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="googleMapsKey"
                    label="Google Map Key"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatSid"
                    label="Twilio Chat SID"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatCredentialSidIos"
                    label="Twilio Chat Credentials IOS"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatCredentialSidAndroid"
                    label="Twilio Chat Credentials Android"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatAuthToken"
                    label="Twilio Chat Auth Token"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatAccountSid"
                    label="Twilio Chat Account SID"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatApiKeySecret"
                    label="Twilio Chat Api Key Secret"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="twilioChatApiKeySid"
                    label="Twilio Chat Api Key SID"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="redisPrefix"
                    label="Redis Prefix"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="awsBucketName"
                    label="AWS Bucket Name"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="sumupClientId"
                    label="Sumup Client ID"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="sumupClientSecret"
                    label="Sumup Client Secret"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="dispatchWebsiteBase"
                    label="Dispatch Website Base"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="bookWebsiteBase"
                    label="Book Website Base"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="osrmAddress"
                    label="OSRM Address"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="emailHost"
                    label="Email Host"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="emailUsername"
                    label="Email Username"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="emailPassword"
                    label="Email Password"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="adminEmailAddress"
                    label="Admin Email Address"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="supportEmailAddress"
                    label="Support Email Address"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="supportContactNumber"
                    label="Support Contact Number"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="driverContactEmailAddress"
                    label="Driver Contact Email Address"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="councils"
                    label="Councils"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="messagebirdKey"
                    label="Messagebird Key"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="messagebirdKeyShort"
                    label="Messagebird Key Short"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="messagebirdTag"
                    label="Messagebird Tag"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIOAuthToken"
                    label="Customer IO Auth Token"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoAppKey"
                    label="Customer IO App Key"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoTripBookedCustomerEmailId"
                    label="Trip Booked Customer IO Email"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoSupplierInfoEmailId"
                    label="Supplier Info Customer IO Email"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoReceiptEmailId"
                    label="Receipt Customer IO Email"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoAdditionalChargeEmailId"
                    label="Additional Charge Customer IO Email"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-text-field
                    v-model="customerIoCancelEmailId"
                    label="Cancel Customer IO Email"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="automaticallyDetermineExpiringDocuments"
                    label="Automatically Determine Expiring Documents"
                  />
                </v-layout>
                <v-layout>
                  <v-divider class="mb-2"></v-divider>
                </v-layout>
                <v-layout class="mt-2 mb-2">
                  <h4>Unconfirmed Bookings Configuration</h4>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="unconfirmedBookingsEnabled"
                    label="Unconfirmed Bookings Enabled"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="unconfirmedWebBookingsEnabled"
                    label="Unconfirmed Web Bookings Enabled"
                  />
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="autoCancelUnconfirmedBookings"
                    label="Auto cancel unconfirmed bookings"
                  />
                </v-layout>
                <v-layout>
                  <v-divider class="mb-2"></v-divider>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="sendOperatorFeedBackMessage"
                    label="Send Operator Feedback Message"
                  />
                </v-layout>
                <v-layout>
                  <v-divider class="mb-2"></v-divider>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                    v-model="showOffersToDrivers"
                    label="Show Offers To Drivers"
                  />
                </v-layout>
                <v-layout>
                  <v-divider class="mb-2"></v-divider>
                </v-layout>
                <v-layout align-center>
                  <v-checkbox
                      v-model="flightTrackingEnabled"
                      label="Flight Tracking Enabled"
                  />
                </v-layout>
                <v-layout>
                  <v-divider class="mb-2"></v-divider>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  small
                  @click="updateVersions"
                >
                  Update
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                pt-5
              >
                <v-btn
                  small
                  @click="initialiseTwilioChat"
                >
                  Initialise Twilio Chat (This will reset chat history as
                  well)
                </v-btn>
              </v-flex>
                <v-flex
                xs12
                pt-5
              >
                <v-btn
                  small
                  @click="setCoordinates"
                >
                  Geocode Drivers Postcode
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";
import OverwatchFilterPopOver from '@/components/overwatch/filters/OverwatchFilterPopOver'

export default {
  name: "Versions",
  components: {
    OverwatchFilterPopOver,
    Overview,
    SimpleCard,
  },
  data: function () {
    return {
      loading: false,
      systemName: "",
      systemCode: "",
      companyAddress: "",
      stripePublishableKey: "",
      googleMapsKey: "",
      twilioChatSid: "",
      twilioChatCredentialSidIos: "",
      twilioChatCredentialSidAndroid: "",
      twilioChatAuthToken: "",
      twilioChatAccountSid: "",
      twilioChatApiKeySecret: "",
      twilioChatApiKeySid: "",
      redisPrefix: "",
      awsBucketName: "",
      sumupClientId: "",
      sumupClientSecret: "",
      dispatchWebsiteBase: "",
      bookWebsiteBase: "",
      osrmAddress: "",
      emailHost: "",
      emailUsername: "",
      emailPassword: "",
      councils: "",
      messagebirdKey: "",
      messagebirdKeyShort: "",
      messagebirdTag: "",
      adminEmailAddress: "",
      driverContactEmailAddress: "",
      supportEmailAddress: "",
      automaticallyDetermineExpiringDocuments: false,
      sendOperatorFeedBackMessage: false,
      customerIOAuthToken: "",
      customerIoTripBookedCustomerEmailId: "",
      customerIoSupplierInfoEmailId: "",
      customerIoReceiptEmailId: "",
      customerIoAdditionalChargeEmailId: "",
      customerIoCancelEmailId: "",
      customerIoAppKey: "",
      supportContactNumber: "",
      unconfirmedBookingsEnabled: 0,
      unconfirmedWebBookingsEnabled: false,
      autoCancelUnconfirmedBookings: 0,
      showOffersToDrivers: 0,
      flightTrackingEnabled: 0,
    };
  },
  mounted: async function () {
    this.get();
  },
  computed: {
    valueOfUnconfirmedBookingEnabled () {
      return (this.unconfirmedBookingsEnabled ? 1 : 0)
    },
    valueOfUnconfirmedWebBookingEnabled () {
      return (this.unconfirmedBookingsEnabled ? 1 : 0)
    },
    valueOfAutoCancelUnconfirmedBookings () {
      return (this.autoCancelUnconfirmedBookings ? 1 : 0)
    }
  },
  methods: {
    setCoordinates: async function () {
      try {
        this.$loadingDialog.show()
        var url = `${this.$store.state.apiUrl}/driver/set_driver_coordinates`;
        let response = await axios.get(url, {
          params: {},
        });
        this.$loadingDialog.hide()
      } catch (error) {
        this.$loadingDialog.hide()
        console.log("Failed to get driver " + error);
      }
    },
    sendTwilioChatInitialisationRequest() {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/system/settings/initialiseTwilio`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            alert("Twilio Chat updated " + res.data.sid);
          } else {
            alert("Failed to initialise twilio");
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
    initialiseTwilioChat() {
      var vm = this;
      if (window.confirm("Are you sure?")) {
        vm.sendTwilioChatInitialisationRequest();
      }
    },
    get: function (p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/system/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            vm.systemName = res.data.systemName;
            vm.companyAddress = res.data.companyAddress;
            vm.systemCode = res.data.systemCode;
            vm.stripePublishableKey = res.data.stripePublishableKey;
            vm.googleMapsKey = res.data.googleMapsKey;
            vm.twilioChatSid = res.data.twilioChatSid;
            vm.twilioChatCredentialSidIos = res.data.twilioChatCredentialSidIos;
            vm.twilioChatCredentialSidAndroid =
              res.data.twilioChatCredentialSidAndroid;
            vm.twilioChatAuthToken = res.data.twilioChatAuthToken;
            vm.twilioChatAccountSid = res.data.twilioChatAccountSid;
            vm.twilioChatApiKeySecret = res.data.twilioChatApiKeySecret;
            vm.twilioChatApiKeySid = res.data.twilioChatApiKeySid;
            vm.redisPrefix = res.data.redisPrefix;
            vm.awsBucketName = res.data.awsBucketName;
            vm.sumupClientId = res.data.sumupClientId;
            vm.sumupClientSecret = res.data.sumupClientSecret;
            vm.dispatchWebsiteBase = res.data.dispatchWebsiteBase;
            vm.bookWebsiteBase = res.data.bookWebsiteBase;
            vm.osrmAddress = res.data.osrmAddress;
            vm.emailHost = res.data.emailHost;
            vm.emailUsername = res.data.emailUsername;
            vm.emailPassword = res.data.emailPassword;
            vm.councils = res.data.councils;
            vm.messagebirdKey = res.data.messagebirdKey;
            vm.messagebirdKeyShort = res.data.messagebirdKeyShort;
            vm.messagebirdTag = res.data.messagebirdTag;
            vm.adminEmailAddress = res.data.adminEmailAddress;
            vm.driverContactEmailAddress = res.data.driverContactEmailAddress;
            vm.supportEmailAddress = res.data.supportEmailAddress;
            vm.automaticallyDetermineExpiringDocuments =
              res.data.automaticallyDetermineExpiringDocuments;
            vm.sendOperatorFeedBackMessage =
              res.data.sendOperatorFeedBackMessage;
            vm.customerIOAuthToken = res.data.customerIOAuthToken;
            vm.customerIoTripBookedCustomerEmailId = res.data.customerIoTripBookedCustomerEmailId;
            vm.customerIoReceiptEmailId = res.data.customerIoReceiptEmailId;
            vm.customerIoAdditionalChargeEmailId = res.data.customerIoAdditionalChargeEmailId;
            vm.customerIoCancelEmailId = res.data.customerIoCancelEmailId;
            vm.customerIoSupplierInfoEmailId = res.data.customerIoSupplierInfoEmailId;
            vm.customerIoAppKey = res.data.customerIoAppKey;
            vm.supportContactNumber = res.data.supportContactNumber;
            vm.unconfirmedBookingsEnabled = res.data.unconfirmedBookingsEnabled;
            vm.unconfirmedWebBookingsEnabled = res.data.unconfirmedWebBookingsEnabled;
            vm.autoCancelUnconfirmedBookings = res.data.autoCancelUnconfirmedBookings;
            vm.showOffersToDrivers = res.data.showOffersToDrivers;
            vm.flightTrackingEnabled = res.data.flightTrackingEnabled;

          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateVersions: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/system/settings/update?systemName=${this.systemName}&systemCode=${this.systemCode}&googleMapsKey=${this.googleMapsKey}&stripePublishableKey=${this.stripePublishableKey}`;

      if (this.twilioChatSid != "") {
        url += `&twilioChatSid=${this.twilioChatSid}`;
      }

      if (this.twilioChatCredentialSidIos != "") {
        url += `&twilioChatCredentialSidIos=${this.twilioChatCredentialSidIos}`;
      }

      if (this.twilioChatCredentialSidAndroid != "") {
        url += `&twilioChatCredentialSidAndroid=${this.twilioChatCredentialSidAndroid}`;
      }

      if (this.twilioChatAuthToken != "") {
        url += `&twilioChatAuthToken=${this.twilioChatAuthToken}`;
      }

      if (this.twilioChatAccountSid != "") {
        url += `&twilioChatAccountSid=${this.twilioChatAccountSid}`;
      }

      if (this.twilioChatApiKeySecret != "") {
        url += `&twilioChatApiKeySecret=${this.twilioChatApiKeySecret}`;
      }

      if (this.twilioChatApiKeySid != "") {
        url += `&twilioChatApiKeySid=${this.twilioChatApiKeySid}`;
      }

      if (this.redisPrefix != "") {
        url += `&redisPrefix=${this.redisPrefix}`;
      }

      if (this.redisPrefix != "") {
        url += `&awsBucketName=${this.awsBucketName}`;
      }

      if (this.redisPrefix != "") {
        url += `&sumupClientId=${this.sumupClientId}`;
      }

      if (this.redisPrefix != "") {
        url += `&sumupClientSecret=${this.sumupClientSecret}`;
      }

      if (this.redisPrefix != "") {
        url += `&dispatchWebsiteBase=${this.dispatchWebsiteBase}`;
      }

      if (this.redisPrefix != "") {
        url += `&bookWebsiteBase=${this.bookWebsiteBase}`;
      }

      if (this.osrmAddress != "") {
        url += `&osrmAddress=${this.osrmAddress}`;
      }

      if (this.emailHost != "") {
        url += `&emailHost=${this.emailHost}`;
      }

      if (this.emailUsername != "") {
        url += `&emailUsername=${this.emailUsername}`;
      }

      if (this.emailPassword != "") {
        url += `&emailPassword=${this.emailPassword}`;
      }

      if (this.councils != "") {
        url += `&councils=${this.councils}`;
      }

      if (this.adminEmailAddress != "") {
        url += `&adminEmailAddress=${this.adminEmailAddress}`;
      }

      if (this.supportEmailAddress != "") {
        url += `&supportEmailAddress=${this.supportEmailAddress}`;
      }

      if (this.driverContactEmailAddress != "") {
        url += `&driverContactEmailAddress=${this.driverContactEmailAddress}`;
      }

      if (this.messagebirdKey != "") {
        url += `&messagebirdKey=${this.messagebirdKey}`;
      }

      if (this.messagebirdKeyShort != "") {
        url += `&messagebirdKeyShort=${this.messagebirdKeyShort}`;
      }

      if (this.messagebirdTag != "") {
        url += `&messagebirdTag=${this.messagebirdTag}`;
      }

      if (this.customerIOAuthToken != null) {
        url += `&customerIOAuthToken=${this.customerIOAuthToken}`;
      }


      if (this.customerIoTripBookedCustomerEmailId != null) {
        url += `&customerIoTripBookedCustomerEmailId=${this.customerIoTripBookedCustomerEmailId}`;
      }
      if (this.customerIoSupplierInfoEmailId != null) {
        url += `&customerIoSupplierInfoEmailId=${this.customerIoSupplierInfoEmailId}`;
      }
      if (this.customerIoReceiptEmailId != null) {
        url += `&customerIoReceiptEmailId=${this.customerIoReceiptEmailId}`;
      }
      if (this.customerIoAdditionalChargeEmailId != null) {
        url += `&customerIoAdditionalChargeEmailId=${this.customerIoAdditionalChargeEmailId}`;
      }
      if (this.customerIoCancelEmailId != null) {
        url += `&customerIoCancelEmailId=${this.customerIoCancelEmailId}`;
      }
      if (this.companyAddress != null) {
        url += `&companyAddress=${this.companyAddress}`;
      }
      if (this.customerIoAppKey != null) {
        url += `&customerIoAppKey=${this.customerIoAppKey}`;
      }
      if (this.supportContactNumber != null) {
        url += `&supportContactNumber=${this.supportContactNumber}`;
      }

      url += `&automaticallyDetermineExpiringDocuments=${this.automaticallyDetermineExpiringDocuments}`;
      url += `&unconfirmedBookingsEnabled=${this.valueOfUnconfirmedBookingEnabled}`;
      url += `&unconfirmedWebBookingsEnabled=${this.valueOfUnconfirmedWebBookingEnabled}`;
      url += `&autoCancelUnconfirmedBookings=${this.valueOfAutoCancelUnconfirmedBookings}`;

      
      if (this.showOffersToDrivers) {
        url += `&showOffersToDrivers=1`;
    
      } else {
        url += `&showOffersToDrivers=0`;
      }
      if (this.sendOperatorFeedBackMessage) {
        url += `&sendOperatorFeedBackMessage=1`;
    
      } else {
        url += `&sendOperatorFeedBackMessage=0`;
      }

      if (this.flightTrackingEnabled) {
        url += `&flightTrackingEnabled=1`;

      } else {
        url += `&flightTrackingEnabled=0`;
      }
  
  
      var completed = this.success;
      let self = this
      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error == "no_error") {
            self.$store.dispatch('dispatch/getDispatchConfiguration')
            self.$snackbar.success('System settings updated')
          } else {
            alert(
              "Failed to update system settings: " + res.data.error.message
            );
          }
        })
        .catch(function (err) {
          alert("Internal Server Error");
        });
    },
  },
};
</script>
